/*
 * Copyright © 2020-2025 XCamera. All Rights Reserved.
 * @Description:
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-10-20 18:00:17
 */
/*
 * Copyright © 2020-2025 XCamera. All Rights Reserved.
 * @Description: 可复用的导出按钮组件
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-08-25 14:55:09
 */
import React from 'react'
import { Button } from 'antd'
import { DownloadOutlined, LoadingOutlined } from '@ant-design/icons'

// 导出按钮图标查表（type 来自 props，universe = download/loading）
const EXPORT_ICONS: Record<string, React.ComponentType<any>> = {
  download: DownloadOutlined,
  loading: LoadingOutlined
}
const ExportIcon = ({ name, ...rest }: { name: string; [k: string]: any }) => {
  const C = EXPORT_ICONS[name]
  return C ? <C {...rest} /> : null
}

/**
 * 导出按钮组件属性接口
 */
export interface ExportButtonProps {
  /** 是否正在导出 */
  exporting?: boolean
  /** 点击处理函数 */
  onClick?: () => void
  /** 按钮文本 */
  text?: string
  /** 导出中的提示文本 */
  loadingText?: string
  /** 按钮类型 - antd 不再支持 'danger' 和 'ghost' */
  type?: 'primary' | 'default' | 'dashed' | 'link' | 'text'
  /** 自定义样式 */
  style?: React.CSSProperties
  /** 是否禁用 */
  disabled?: boolean
  /** 图标类型 */
  iconType?: string
  /** 加载图标类型 */
  loadingIconType?: string
  /** 按钮尺寸 - antd 使用 'middle' 替代 'default' */
  size?: 'small' | 'middle' | 'large'
}

/**
 * 导出按钮组件
 * 提供统一的导出按钮样式和加载状态处理
 */
const ExportButton: React.FC<ExportButtonProps> = ({
  exporting = false,
  onClick,
  text = '导出表格',
  loadingText = '生成中',
  type = 'primary',
  style,
  disabled = false,
  iconType = 'download',
  loadingIconType = 'loading',
  size = 'middle'
}) => {
  /**
   * 处理按钮点击
   */
  const handleClick = () => {
    if (!exporting && !disabled && onClick) {
      onClick()
    }
  }

  /**
   * 获取按钮样式
   */
  const getButtonStyle = (): React.CSSProperties => {
    const defaultStyle: React.CSSProperties = {
      overflow: 'visible',
      fontSize: 16,
      fontWeight: 'bold',
      color: '#fff',
      marginLeft: 10,
      background:
        'linear-gradient(90deg, rgba(255, 111, 243, 1) 0%, rgba(1, 146, 253, 1) 100%)'
    }

    // 如果正在导出，设置激活状态的颜色
    if (exporting && type === 'primary') {
      defaultStyle.backgroundColor = '#1890ff'
      defaultStyle.borderColor = '#1890ff'
    }

    defaultStyle.borderColor = 'transparent'
    defaultStyle.borderWidth = 0

    return { ...defaultStyle, ...style }
  }

  return (
    <div>
      <span>符合筛选条件的全部内容</span>
      <Button
        type={type}
        size={size}
        style={getButtonStyle()}
        onClick={handleClick}
        title="导出全部表格"
        disabled={disabled || exporting}
        loading={false} // 使用自定义的加载状态
      >
        {exporting ? (
          <>
            <ExportIcon
              name={loadingIconType}
              style={{ marginRight: 5, fontSize: 20, color: '#fff' }}
            />
            {loadingText}
          </>
        ) : (
          <>
            <ExportIcon
              name={iconType}
              style={{ marginRight: 5, fontSize: 20, color: '#fff' }}
            />
            {text}
          </>
        )}
      </Button>
    </div>
  )
}

export default ExportButton
